import React from "react";
import {Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Typography} from "@mui/material";

export const KpiWebTable = ({data, loading}) => {
    if (loading) {
        return (
            <Box sx={{display: 'flex', justifyContent: 'center', p: 4}}>
                <CircularProgress/>
            </Box>
        );
    }

    if (!data || data.length === 0) {
        return (
            <Typography sx={{p: 2, textAlign: 'center'}}>No data available</Typography>
        );
    }

    const calculateTotal = (field) => {
        return data.reduce((sum, row) => {
            const value = parseFloat(row[field]) || 0;
            return sum + value;
        }, 0);
    };

    const formatValue = (value, isPercent = false) => {
        if (value === null || value === undefined) return '0';
        if (isPercent) {
            return parseFloat(value).toFixed(1);
        }
        return value;
    };

    return (
        <TableContainer component={Paper} sx={{maxHeight: 600}}>
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{whiteSpace: 'nowrap'}}>KPI User</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Web assigned</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Converted</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Web conversion %</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Web to Onsite</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Web to Inside</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Outgoing Email</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Number Of Notes</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, index) => (
                        <TableRow 
                            key={index}
                            sx={{
                                backgroundColor: row.totalCount === 0 ? '#ffebee' : 
                                                row.firstContactMode >= 15 ? '#e8f5e9' : 
                                                row.totalCount < 2 ? '#fff9c4' : 'inherit'
                            }}
                        >
                            <TableCell sx={{whiteSpace: 'nowrap'}}>{row.name || ''}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.web_assigned)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.converted)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.web_percentage, true)}%</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.web_outside)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.web_inside)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.email_count)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.note_count)}</TableCell>
                        </TableRow>
                    ))}
                    <TableRow sx={{backgroundColor: '#f5f5f5', fontWeight: 'bold'}}>
                        <TableCell sx={{whiteSpace: 'nowrap'}}><strong>Total</strong></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}><strong>{calculateTotal('email_count')}</strong></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

